/*=============================
=         BMI Calculator      =
=============================*/

// Tab Switching
[].slice.call(document.querySelectorAll('.tabs-list button')).forEach(function(tabButton) {
    tabButton.addEventListener('click', function() {
        var tabPanel = document.getElementById(this.getAttribute('aria-controls')),
            current = this.parentNode.parentNode.querySelector('button[aria-selected="true"]');

        if(this !== current) {
            if(current) {
                current.setAttribute('aria-selected', 'false');
                current.setAttribute('tabindex', '-1');
                document.getElementById(current.getAttribute('aria-controls')).classList.add('hidden');
            }

            this.setAttribute('aria-selected', 'true');
            this.removeAttribute('tabindex');
            tabPanel.classList.remove('hidden');
            tabPanel.focus({preventScroll:true});
        }
    });
});

// Unit Switching
[].slice.call(document.querySelectorAll('select[name="unit"]')).forEach(function(select) {
    select.addEventListener('change', function() {
        var value = this.value,
            parent = this.parentNode.parentNode,
            measurementsRow = parent.querySelector('.row.measurements > div:first-child'),
            height = parent.querySelector('input[name="height-feet"]'),
            weight = parent.querySelector('input[name="weight"]');

        if(value == 'metric')
            measurementsRow.classList.remove('half');
        else
            measurementsRow.classList.add('half');

        height.placeholder = height.getAttribute('data-'+value);
        weight.placeholder = weight.getAttribute('data-'+value);
    });
});

[].slice.call(document.querySelectorAll('.bmi-calculator-form')).forEach(function(form) {
    form.addEventListener('submit', bmiFormProcess);
});

function bmiFormProcess(e) {
    if('performance' in window === false)
        return true;

    e.preventDefault();

    var form = this,
        data = new FormData(form),
        button = this.querySelector('button[type="submit"]');

    button.disabled = true;

    let res

    axios.post('/token')
        .then(function (response) {
            res = response.data
            axios.post(form.action, data, {
                    headers: {
                        "X-CSRF-TOKEN": res.token
                    }
                })
                .then(function(r) {
                    clearBMIErrors(form);
                    button.disabled = false;
                    form.querySelector('.bmi-result span').innerHTML = r.data.result;

                    if(typeof dataLayer !== 'undefined')
                        dataLayer.push({'event': 'FormSubmission'});
                })
                .catch(function (e) {
                    button.disabled = false;

                    // console.log(e.response.data.errors);

                    if(e.response.status===422) {
                        clearBMIErrors(form);
                        setBMIErrors(form, e.response.data.errors);
                    }
                })
    })
    .then(function (t) {
        if (!res.auth) {
            axios.delete('/token')
        }
    });
}

function clearBMIErrors(form) {
    var errors = form.getElementsByClassName('error');

    for(var e=errors.length - 1; e>=0; e--)
        errors[e].classList.remove('error');
}

function setBMIErrors(form, errors) {
    var firstField = false;

    errors.forEach(function(item, index) {
        var field = form.querySelector('*[name="'+item+'"]');

        if(field)
            field.classList.add('error');

        if(!firstField) {
            field.focus();
            firstField = true;
        }
    });
}
